import { render } from "./TNC.vue?vue&type=template&id=35d6b5ba&scoped=true"
import script from "./TNC.vue?vue&type=script&lang=js"
export * from "./TNC.vue?vue&type=script&lang=js"

import "./TNC.vue?vue&type=style&index=0&id=35d6b5ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d6b5ba"]])

export default __exports__